module.exports = __webpack_public_path__ + "img/popup12.140d2877.png";